import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getLoggedUser } from "~/store/selectors/selector.users";

export const useProjectPermission = () => {
  const loggedUser = useSelector(getLoggedUser);
  const canUserManageProject = useCallback(
    (project) => {
      if (loggedUser.isOwner()) return true;
      if (project?.leader_id === loggedUser.id) return true;
      return (
        loggedUser.isMember() &&
        loggedUser.custom_permissions.indexOf(`can_manage_projects`) > -1 &&
        project?.created_by_id === loggedUser.id
      );
    },
    [loggedUser]
  );

  return { canUserManageProject };
};
